import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminLayout from '../components/admin/Layout/AdminLayout';
import Login from '../pages/admin/Login';
import Dashboard from '../pages/admin/Dashboard';
import Companies from '../pages/admin/Companies';
import ChartOfAccounts from '../pages/admin/ChartOfAccounts';
import AccountingEntries from '../pages/admin/AccountingEntries';
import ThirdParties from '../pages/admin/ThirdParties';
import Invoices from '../pages/admin/Invoices';
import Retentions from '../pages/admin/Retentions';
import Reports from '../pages/admin/Reports';
import Payroll from '../pages/admin/Payroll';
import BankReconciliation from '../pages/admin/BankReconciliation';
import TaxReports from '../pages/admin/TaxReports';
import Users from '../pages/admin/Users';
import MonthlyAnalysis from '../pages/admin/MonthlyAnalysis';

// Componente para proteger rutas
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin/login" replace />} />
      <Route path="/admin/login" element={<Login />} />
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="companies" element={<Companies />} />
        <Route path="chart-of-accounts" element={<ChartOfAccounts />} />
        <Route path="accounting-entries" element={<AccountingEntries />} />
        <Route path="third-parties" element={<ThirdParties />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="retentions" element={<Retentions />} />
        <Route path="reports" element={<Reports />} />
        <Route path="payroll" element={<Payroll />} />
        <Route path="bank-reconciliation" element={<BankReconciliation />} />
        <Route path="tax-reports" element={<TaxReports />} />
        <Route path="monthly-analysis" element={<MonthlyAnalysis />} />
        <Route path="users" element={<Users />} />
        <Route path="" element={<Navigate to="/admin/dashboard" replace />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;

